const authTypes =  {
    SET_AUTH_TOKEN: "SET_AUTH_TOKEN",
    SET_AUTH_ERROR: "SET_AUTH_ERROR",
    SET_USER_DETAILS: "SET_USER_DETAILS",
    SET_AUTH_LOADER: 'SET_AUTH_LOADER',
    SET_REDIRECT_SUCCESS: 'SET_REDIRECT_SUCCESS',
}

export default authTypes;
